export const roundToDecimals = (value, decimals = 2) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  return parseFloat(n.toFixed(decimals))
}

/** @deprecated Use roundToDecimals */
export const truncateToDecimals = roundToDecimals

export const formatRoundedNumber = (value) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return '0.00'
  return n.toFixed(2)
}

export const formatTruncatedNumber = formatRoundedNumber

export const formatMoney = (value) => `${formatRoundedNumber(value)}€`

export const getItemIvaRate = (item) => {
  const rawIva = item?.IVACP ?? item?.IVA ?? 0
  const normalized = Number(rawIva)
  return Number.isFinite(normalized) ? normalized : 0
}

export const grossToNet = (amount, iva) => {
  const n = Number(amount)
  if (!Number.isFinite(n)) return 0
  const divisor = 1 + (Number(iva) || 0) / 100
  return divisor > 0 ? n / divisor : n
}

/** Unit price shown in the Price column (rounded gross or net). */
export const getLinePrice = (item, pricesIncludeIva = true) => {
  const raw = Number(item?.marketPriceCP) || 0
  const rate = getItemIvaRate(item)
  if (pricesIncludeIva || rate === 0) {
    return roundToDecimals(raw, 2)
  }
  return roundToDecimals(grossToNet(raw, rate), 2)
}

/** Line total = round(round(PRECIO, 2) × round(Cantidad, 2), 2). */
export const getLineTotalFromUnitPrice = (unitPrice, quantity) => {
  const roundedUnitPrice = roundToDecimals(unitPrice, 2)
  const roundedQuantity = roundToDecimals(quantity ?? 0, 2)
  return roundToDecimals(roundedUnitPrice * roundedQuantity, 2)
}

export const getLineTotal = (item, pricesIncludeIva = true) =>
  getLineTotalFromUnitPrice(
    getLinePrice(item, pricesIncludeIva),
    item?.quantity,
  )

/** Base imponible = Cantidad × unit price sin IVA (matches albarán BASE IMPONIBLE rows). */
export const getLineBaseImponible = (item, pricesIncludeIva = true) => {
  const rate = Number(item?.IVACP ?? item?.IVA ?? 0) || 0
  if (pricesIncludeIva) {
    return roundToDecimals(getLineTotal(item, true) / (1 + rate / 100), 2)
  }
  return getLineTotal(item, false)
}
